export default { "backEndUrl": 'https://template.dblandit.io/' }